import { render, staticRenderFns } from "./OperaDeviceRoleWindow.vue?vue&type=template&id=5659a1fe&"
import script from "./OperaDeviceRoleWindow.vue?vue&type=script&lang=js&"
export * from "./OperaDeviceRoleWindow.vue?vue&type=script&lang=js&"
import style0 from "./OperaDeviceRoleWindow.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports